interface Step {
  number: string;
  headline: string;
  description: string;
}

const STEPS: Step[] = [
  {
    number: '01',
    headline: 'Coach builds a reference template.',
    description:
      'Upload a demo video, annotate movement phases and key cues, then set scoring thresholds for every checkpoint that matters.',
  },
  {
    number: '02',
    headline: 'Athlete uploads a video.',
    description:
      'Drop in a clip from any angle. PointeTracer detects pose landmarks and aligns the movement to the template automatically.',
  },
  {
    number: '03',
    headline: 'PointeTracer scores the movement.',
    description:
      'Per-phase scores, body-region heatmaps, and an AI coaching narrative — all generated in seconds, ready for the next practice session.',
  },
];

export default function HowItWorks() {
  return (
    <section className="py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-14">
          <p
            className="mb-3 text-xs font-medium uppercase tracking-widest"
            style={{ color: 'var(--color-brand-primary)', letterSpacing: '0.12em' }}
          >
            How it works
          </p>
          <h2 className="text-h1" style={{ color: 'var(--color-text-primary)' }}>
            From reference video to coached feedback in three steps.
          </h2>
        </div>

        {/* Steps grid */}
        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {STEPS.map((step) => (
            <article
              key={step.number}
              className="relative rounded-2xl p-8 transition-all duration-150"
              style={{
                background: 'var(--color-surface-raised-1)',
                border: '1px solid var(--color-border-subtle)',
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLElement).style.borderColor =
                  'var(--color-border-strong)';
                (e.currentTarget as HTMLElement).style.background =
                  'var(--color-surface-raised-2)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLElement).style.borderColor =
                  'var(--color-border-subtle)';
                (e.currentTarget as HTMLElement).style.background =
                  'var(--color-surface-raised-1)';
              }}
            >
              {/* Numbered badge */}
              <div
                className="mb-6 inline-flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold"
                style={{
                  fontFamily: 'var(--font-mono)',
                  backgroundColor: 'var(--color-brand-primary)',
                  color: 'var(--color-text-inverse)',
                }}
              >
                {step.number}
              </div>

              <h3 className="text-h3 mb-3" style={{ color: 'var(--color-text-primary)' }}>
                {step.headline}
              </h3>
              <p className="text-body-md" style={{ color: 'var(--color-text-secondary)' }}>
                {step.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
